import * as React from "react";

const StockOutOfStock: React.FC = () => {
    return (
        <svg
            width="12px"
            height="12px"
            viewBox="0 0 12 12"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill="currentColor"
                d="M6,12.5 C8.14359382,12.5 10.1243558,11.3564062 11.196153,9.5 C12.2679494,7.64359379 12.2679494,5.35640657 11.196153,3.5 C10.1243558,1.64359379 8.14359382,0.5 6,0.5 C3.85640672,0.5 1.87564436,1.64359379 0.803847581,3.5 C-0.267949194,5.35640657 -0.267949194,7.64359379 0.803847581,9.5 C1.87564436,11.3564062 3.85640672,12.5 6,12.5 Z M6.56250027,3.5 L6.56250027,4.0625 L6.56250027,6.6875 L6.56250027,7.25 L5.43750027,7.25 L5.43750027,6.6875 L5.43750027,4.0625 L5.43750027,3.5 L6.56250027,3.5 Z M5.43750027,9.125 L5.43750027,8 L6.56250027,8 L6.56250027,9.125 L5.43750027,9.125 Z"
                transform="translate(0 -.5)"
            />
        </svg>
    );
};

export default React.memo(StockOutOfStock);
